<label class="input-row">
  <input
    class="checkbox"
    type="checkbox"
    [id]="inputId"
    [formControl]="cpFormControl"
    [ngModel]="cpModel"
    [attr.required]="required" />
  <span
    class="checkbox-icon"
    [class.checkbox-icon-checked]="cpModel"
    (click)="onClick($event)">
  </span>
  <span *ngIf="label" class="label" (click)="onClick($event)">{{label | translate}}</span>
</label>
<cp-validation-error *ngIf="showErrors" [errors]="cpFormControl.errors" [validate]="validate">
</cp-validation-error>

